import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=10a15558&scoped=true&"
import script from "./CustomPagination.vue?vue&type=script&lang=js&"
export * from "./CustomPagination.vue?vue&type=script&lang=js&"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=10a15558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a15558",
  null
  
)

export default component.exports